import React, { useLayoutEffect, useRef } from 'react';
import CtaLink from './CtaLink';
import AnimatedWords from './AnimatedWords';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Recognition = () => {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        const ctx = gsap.context(() => {
            const tl = gsap.timeline({
                defaults: { ease: 'power2.out' },
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: 'top 75%',
                    toggleActions: 'play none none none',
                    once: true
                }
            });
            const headingWords = containerRef.current?.querySelectorAll('.rec-copy h2 [data-animated-word]');
            if (headingWords && headingWords.length) {
                tl.fromTo(headingWords, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: 'power3.out', stagger: 0.06, clearProps: 'transform' }, 0);
            }
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section id="recognition" className="container" ref={containerRef}>
            <div className="rec-card">
                <div className="rec-bg z-10" aria-hidden="true" style={{ backgroundImage: "url('/images/recognized_background.webp')" }}></div>
                <div className="rec-copy z-20 flex flex-col">
                    <h2 className='text-center sm:text-left text-2xl md:text-3xl lg:text-4xl'>
                        <AnimatedWords auto={false} lines={["Recognized as One of", "The Leading Company!"]} accentMap={[[], [2]]} />
                    </h2>
                    <p className="muted w-full sm:w-[40%] text-sm md:text-base lg:text-lg">
                        Logistic service provider company plays a pivotal role in the global supply
                        chain ecosystem.
                    </p>

                    <div className='w-fit self-end sm:self-start'>
                        <CtaLink href="/contact" primaryText="Contact Us" className="text-black" fill="black" />
                    </div>
                </div>
                <div className="rec-media hidden sm:block">
                    <div className="flag-bars" aria-hidden="true">
                        <div className="bar bar-red"></div>
                        <div className="bar bar-blue"></div>
                        <div className="bar bar-green"></div>
                    </div>
                    <img src="/images/recognized_person.webp" alt="Courier holding parcel" />
                </div>
            </div>
        </section>
    );
};

export default Recognition;


